import Settings from '@/app/config/appConfig'

// Standalone mobile-app purchase flow for "private" users (EasyTachoMobile /
// EasyTachoMobileProd realm). Decoupled from the main web app's OIDC userManager
// (bound to the company EasyTacho realm) — private users authenticate against
// their own realm. The page is opened either:
//   - from the React Native app, which forwards its access token in the URL hash
//     (#access_token=...), or
//   - directly in a browser, where a small email/password login (Keycloak direct
//     grant) is shown as a fallback (mainly for testing).
//
// NOTE: we deliberately do NOT read new `process.env.*` keys here — rspack only
// injects a fixed known set, and referencing an undefined one ships a bare
// `process.env.X` that throws "process is not defined" in the browser. The
// private realm is fixed per host, so we derive it from the hostname instead.

// The private realms live on this Keycloak host (same for dev + prod).
const KEYCLOAK_URL = 'https://auth.easytacho.online'

const isProdHost =
  typeof window !== 'undefined' && window.location.hostname.startsWith('app.')

// dev/stage (install01, localhost) → EasyTachoMobile; prod (app.*) → EasyTachoMobileProd.
export const PRIVATE_REALM = isProdHost ? 'EasyTachoMobileProd' : 'EasyTachoMobile'
// Client id is the same across both realms.
export const PRIVATE_CLIENT_ID = 'EasyTachoMobile'

export const PRIVATE_TOKEN_URL = `${KEYCLOAK_URL}/realms/${PRIVATE_REALM}/protocol/openid-connect/token`

// API base (same origin/proxy the main axios instance uses). Endpoints are
// reached through the gateway's /config-api/* prefix.
export const API_BASE = (Settings.serverAddress ?? '').replace(/\/$/, '')

export const MOBILE_PURCHASE_API = `${API_BASE}/config-api/mobile/purchase`

const TOKEN_STORAGE_KEY = 'mobapp_access_token'

export function storeMobileToken(token: string): void {
  try {
    window.sessionStorage.setItem(TOKEN_STORAGE_KEY, token)
  } catch {
    /* sessionStorage unavailable (private mode) — token stays in memory only */
  }
}

export function readMobileToken(): string | null {
  try {
    return window.sessionStorage.getItem(TOKEN_STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearMobileToken(): void {
  try {
    window.sessionStorage.removeItem(TOKEN_STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
